import { Component } from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ModalNavPage} from "../modal-nav/modal-nav";
import {GlobalProvider} from "../../providers/global/global";

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
  public user: any;
  // private _registerURL = 'http://192.168.178.79:8080/api/v2/register';
  // private _settingDocument: any = null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private http: HttpClient,
              private modalNavPage: ModalNavPage,
              private globalProvider: GlobalProvider,
              private alertCtrl: AlertController) {
    this.user = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: ''
    }


    // this.dataProvider.getDocmentById('setting')
    //   .then((_settingDocument) => {
    //     this._settingDocument = _settingDocument;
    //   });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterPage');
  }

  public register(formValues: any): void {

    let firstName = formValues.firstName;
    let lastName = formValues.lastName;
    let email = formValues.email;
    let password = formValues.password;

    this.http.post(this.globalProvider.apiURL+'/v1/register', {
      email: email,
      password: password,
      firstName: firstName,
      lastName: lastName
    })
      .subscribe((result: any) => {

        let message: string = "Fehler Bitte wenden Sie sich an support@cleverreport.de";
        let title: string = "Registrierung fehlgeschlagen";

        if(result.meta && result.meta.success){
          title = "Registrierung erfolgreich";
          message = result.message;
          let alert = this.alertCtrl.create({
            title: title,
            message: message,
            buttons: [
              {
                text: 'OK',
                handler: () => {
                  this.navCtrl.pop();
                }
              }
            ]
          });
          alert.present();
        }else {
          let alert = this.alertCtrl.create({
            title: title,
            message: result.error,
            buttons: [
              {
                text: 'OK',
                handler: () => {
                }
              }
            ]
          });
          alert.present();
        }




      }, (error) => {
        console.dir(error);
      })


  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts